"use client";

import React from "react";

const tree = [
    ["Jigoro Kano"],
    ["Tomita Tsunejirō"],
    ["Mitsuyo Maeda"],
    ["Carlos Gracie", "Hélio Gracie"],
    ["João Alberto Barreto"],
    ["Álvaro Barreto", "Flávio Behring"],
    ["Sílvio Behring", "Maurício “Behring” Pereira"],
    ["Márcio Corleta"],
    ["Gabriel Azambuja", "Alexandre Fortis", "Rafael Azambuja"],
    ["Roberto Wosiack"]
];

const FamilyTreeMobile = () => {
    return (
        <div className="flex flex-col items-center gap-4 relative">
            {tree.map((group, index) => (
                <div key={index} className="flex flex-col items-center gap-3 relative">
                    {group.map((name) => (
                        <div
                            key={name}
                            className={`px-4 py-2 rounded-xl shadow-md text-sm text-center w-full max-w-xs
              ${
                  name === "Roberto Wosiack"
                      ? "bg-red-600 text-white font-semibold scale-105 shadow-xl"
                      : "bg-white text-gray-800"
              }`}
                        >
                            {name}
                        </div>
                    ))}

                    {/* seta vertical */}
                    {index < tree.length - 1 && (
                        <div className="w-px h-8 bg-gray-400 relative">
                            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-6 border-l-transparent border-r-transparent border-t-gray-400"></div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FamilyTreeMobile;
